import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-path=\"url(#a)\" clip-rule=\"evenodd\"><path d=\"M4.667 2A.667.667 0 0 0 4 2.667v10.666c0 .369.298.667.667.667h6.666a.667.667 0 0 0 .667-.667V2.667A.667.667 0 0 0 11.333 2zm-2 .667a2 2 0 0 1 2-2h6.666a2 2 0 0 1 2 2v10.666a2 2 0 0 1-2 2H4.667a2 2 0 0 1-2-2z\"></path><path d=\"M7.333 12c0-.368.299-.667.667-.667h.007a.667.667 0 0 1 0 1.334H8A.667.667 0 0 1 7.333 12\"></path></g><defs><clipPath id=\"a\"><path fill=\"currentColor\" d=\"M0 0h16v16H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })